import { Upload } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function DataImportPage() {
  return (
    <PlaceholderPage
      icon={Upload}
      title="Import danych"
      description="Importuj dane z plik\u00F3w CSV lub Excel \u2014 kontrahent\u00F3w, osoby, produkty i szanse sprzeda\u017Cy."
    />
  )
}
